import { render, staticRenderFns } from "./MailV2.vue?vue&type=template&id=3b8b5944&scoped=true"
import script from "./MailV2.vue?vue&type=script&lang=js"
export * from "./MailV2.vue?vue&type=script&lang=js"
import style0 from "./MailV2.vue?vue&type=style&index=0&id=3b8b5944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b5944",
  null
  
)

export default component.exports